/* Collection filters (COLL-03).
   Server-rendered GET form works without JS. This script only enhances it:
   - marks the toolbar (.facets-js) so CSS turns the form into a mobile panel
   - mobile (< 990px): Filtry opens #FacetsPanel (scroll lock, `inert` on the rest
     of the page, focus into the panel); closes on X, Esc, overlay click;
     focus returns to the Filtry button. No auto-submit there - "Pokaż produkty" submits.
   - desktop: checkbox and price changes submit the form (change, not keystroke).
   - the sort select submits on change at every width.
   Uses `inert` instead of a dialog element so the form stays plain inline markup without JS. */
(function () {
  var toolbar = document.querySelector('.collection-toolbar');
  var panel = document.getElementById('FacetsPanel');
  var form = document.getElementById('FacetsForm');
  if (!toolbar || !panel || !form) return;

  toolbar.classList.add('facets-js');

  var opener = toolbar.querySelector('[data-facets-open]');
  var closer = panel.querySelector('[data-facets-close]');
  var inner = panel.querySelector('[data-facets-inner]');
  var sort = document.getElementById('SortBy');
  var desktop = window.matchMedia('(min-width: 990px)');
  var inertTargets = [];

  function isOpen() {
    return panel.classList.contains('is-open');
  }

  function setInert(on) {
    if (!on) {
      inertTargets.forEach(function (el) { el.inert = false; });
      inertTargets = [];
      return;
    }
    // Everything on the page that does not contain the panel.
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el.contains(panel) || el.tagName === 'SCRIPT') return;
      el.inert = true;
      inertTargets.push(el);
    });
    // Siblings of the toolbar chain inside <main>.
    var node = panel;
    while (node.parentElement && node.parentElement !== document.body) {
      var parent = node.parentElement;
      Array.prototype.forEach.call(parent.children, function (el) {
        if (el === node || el.tagName === 'SCRIPT' || el.tagName === 'STYLE') return;
        el.inert = true;
        inertTargets.push(el);
      });
      node = parent;
    }
  }

  function open() {
    if (isOpen() || desktop.matches) return;
    panel.classList.add('is-open');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
    setInert(true);
    if (inner) inner.focus();
  }

  function close(returnFocus) {
    if (!isOpen()) return;
    panel.classList.remove('is-open');
    if (opener) opener.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
    setInert(false);
    if (returnFocus && opener) opener.focus();
  }

  if (opener) opener.addEventListener('click', open);
  if (closer) closer.addEventListener('click', function () { close(true); });
  panel.addEventListener('click', function (event) {
    if (event.target === panel) close(true);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen()) close(true);
  });
  desktop.addEventListener('change', function (event) {
    if (event.matches) close(false);
  });

  // Shopify parses only a dot decimal (12,5 would be cut to 12): normalise the Polish comma.
  form.addEventListener('submit', function () {
    form.querySelectorAll('input[name^="filter.v.price."]').forEach(function (input) {
      input.value = input.value.replace(/\s/g, '').replace(',', '.');
    });
  });

  form.addEventListener('change', function (event) {
    if (!desktop.matches) return;
    var target = event.target;
    if (target && target.name && target.name.indexOf('filter.') === 0) form.requestSubmit();
  });

  if (sort) {
    sort.addEventListener('change', function () {
      form.requestSubmit();
    });
  }
})();
